import React from "react";
import Print58 from "./print58";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPrint} from "@fortawesome/free-solid-svg-icons";
import ReactToPrint from "react-to-print";

const LeapPrint = ({...props}) => {
    const {results: {list}} = props;

    const renderPrintsX4 = (object) => {
        let prints = [];
        for (let i = 0; i < 4; i++) {
            prints.push(
                <Print58 isShow key={i} className="mr-3 print58" object={object}/>
            )
        }
        return prints;
    };

    return <div className="row col-sm-12">
        {
            list.map((result, i) => {
                let componentRef = React.createRef();
                let componentRefX4 = React.createRef();
                return <div key={i} className="col-sm-3">
                    <div className="d-flex justify-content-between">
                        {/*Print One*/}
                        <ReactToPrint
                            trigger={() => <button className="bg-transparent border-0">
                                <FontAwesomeIcon style={{fontSize: 32}} className="text-red-c mt-1"
                                                 icon={faPrint}/>
                            </button>}
                            content={() => componentRef}
                        />
                        <div style={{display: "none"}}>
                            <div ref={el => (componentRef = el)}>
                                <Print58 object={result}/>
                            </div>
                        </div>

                        {/*Print X4*/}
                        <ReactToPrint
                            trigger={() => <button style={{fontSize: 32, marginRight: "6vw"}}
                                                   className="bg-transparent border-0 text-red-c mt-1 f-time-roman">
                                <FontAwesomeIcon icon={faPrint}/>x4
                            </button>}
                            content={() => componentRefX4}
                        />
                    </div>

                    <div style={{display: "none"}}>
                        <div className="row A4" ref={el => (componentRefX4 = el)}>
                            {
                                renderPrintsX4(result)
                            }
                        </div>
                    </div>

                    <Print58 isShow className="print80" object={result}/>
                </div>
            })
        }
    </div>
};

export default LeapPrint;